import React from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import "../modal.css";
import html2pdf from "html2pdf.js";
import jiviniLogo from "../../../assets/jivinilogo.png";
import PdfCurrentOrdersTableData from "../../tables/pdfCurrentOrdersTableData";
import moment from "moment";

const OrderHistoryPdfView = ({ id, show, orderHistoryDetail, handleClose }) => {
  const data = [
    {
      title: "Order ID",
      content: orderHistoryDetail?.order_id
        ? orderHistoryDetail?.order_id
        : "--",
    },
    {
      title: "Order Date & Time",
      content: orderHistoryDetail?.createdAt
        ? moment(orderHistoryDetail?.createdAt).format("DD MMM YYYY, HH:mm A")
        : "--",
    },
    {
      title: "Invoice ID",
      content: orderHistoryDetail?.invoice_id
        ? orderHistoryDetail?.invoice_id
        : "--",
    },
    {
      title: "Invoicing Date & Time",
      content: orderHistoryDetail?.updatedAt
        ? moment(orderHistoryDetail?.updatedAt).format("DD MMM YYYY, HH:mm A")
        : "--",
    },
  ];

  const data2 = [
    {
      title: "Division",
      content: orderHistoryDetail?.vendorDivision?.name
        ? orderHistoryDetail?.vendorDivision?.name
        : "--",
    },
    {
      title: "Doctor Name",
      content: orderHistoryDetail?.doctor?.name
        ? orderHistoryDetail?.doctor?.name
        : "--",
    },
    {
      title: "Pharmacy Name",
      content: orderHistoryDetail?.pharmacy_id
        ? orderHistoryDetail?.pharmacy?.pharmacy_name
        : orderHistoryDetail?.doctor?.pharmacy_type == "attach"
        ? orderHistoryDetail?.doctor?.doctorAttachPharmacy?.pharmacy
            ?.pharmacy_name
        : orderHistoryDetail?.doctor?.pharmacy_type == "self"
        ? orderHistoryDetail?.doctor?.doctorSelfPharmacy?.pharmacy_name
        : orderHistoryDetail?.doctor?.pharmacy_type == "dispensing" &&
          "Dispensing",
    },
    ,
    {
      title: "Order Status",
      content: orderHistoryDetail?.status ? orderHistoryDetail?.status : "--",
    },
  ];
  const exportToPdf = () => {
    const toRender = document.getElementById("toRender");
    const options = {
      margin: [30, 10],
      filename: "orders.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { dpi: 192, letterRendering: true },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(toRender).save();
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName="current-orders-view-container col-10 mx-auto px-3"
      >
        <ModalHeader>
          <div className=" d-flex justify-content-between w-100 ">
            <div>
              <span className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-0">
                {orderHistoryDetail?.order_id} - View
              </span>
            </div>
            <div className="d-flex justify-content-end  gap-2">
              <div className="mt-1">
                <button
                  type="button"
                  onClick={() => {
                    exportToPdf();
                  }}
                  className="modal-submit-btn text-white px-4 py-2 fs_14"
                >
                  print
                </button>
              </div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="w-100 h-100">
          <div
            className="w-100"
            style={{ overflowY: "scroll", height: "40rem" }}
          >
            <div id="toRender" className="mx-2">
              <div className="my-2 mb-4">
                <img src={jiviniLogo} />
              </div>
              <div className="d-flex ">
                <div className="col-6 col-lg-6">
                  {data.map((items, index) => (
                    <div className="d-flex gap-" key={index}>
                      <div className="col-6 col-sm-5">
                        <span className=" fs_14">
                          {items.title}
                        </span>
                      </div>
                      <span className="fs_14 ms-3">{items.content}</span>
                    </div>
                  ))}
                </div>
                <div className="col-6">
                  {data2.map((items, index) => (
                    <div className="d-flex" key={index}>
                      {items?.title != "Order Status" ? (
                        <>
                          <div className="col-6 col-sm-4">
                            <span className=" fs_14">
                              {items?.title}
                            </span>
                          </div>
                          <span className="fs_14 ms-3 col-6 mt-1">
                            {items?.content}
                          </span>
                        </>
                      ) : (
                        <>
                          <div className="col-6 col-sm-4">
                            <span className={`color_747f9e fs_14`}>
                              {items?.title}
                            </span>
                          </div>
                          <span
                            className={`fs_14 ms-3 col-6 mt-1 ${
                              orderStatus.find(
                                (e) => e?.status == items?.content
                              )?.color
                            }`}
                          >
                            {
                              orderStatus.find(
                                (e) => e?.status == items?.content
                              )?.value
                            }
                          </span>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-3">
                <p className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-2 label-text">
                  Order Details - {orderHistoryDetail?.order_id}
                </p>
                <div className="mt-3">
                  <PdfCurrentOrdersTableData
                    orderProducts={orderHistoryDetail?.orderProducts}
                    total={orderHistoryDetail?.total}
                  />
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default OrderHistoryPdfView;

export const orderStatus = [
  { status: "pending", value: "Approval Pending", color: "text-warning" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partially Invoiced",
    color: "Medium_Purple",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "acknowledged", value: "Acknowledged", color: "text-danger" },
  {
    status: "partially_acknowledged",
    value: "Partially acknowledged",
    color: "Medium_Purple",
  },
  { status: "hold", value: "Hold", color: "text-danger" },
];
